import { get, query } from './client';
var endpoint = '/api/auth/logs';
var authLogApi = {
    logs: function (filter, page, size, success, from, to) {
        if (size === void 0) { size = 25; }
        return get(query(endpoint + "/filter", { filter: filter, success: success, from: from, to: to, page: page, size: size }));
    },
};
export default authLogApi;
